import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ref, reactive } from "vue";
import { useI18n } from "vue-i18n";
import api from "@/api/system/users";
import { ElMessage } from "element-plus";
export default {
  __name: 'tagDialog',
  props: {
    labelList: {
      type: Array,
      default: () => []
    }
  },
  emits: ["loadList"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const showDialog = ref(false);
    const params = reactive({
      tagIds: [],
      id: ""
    });
    const rules = {
      tagIds: [{
        required: true,
        message: t("common.pleaseSelect", {
          val: t("users.form.tag")
        }),
        trigger: "change"
      }]
    };
    const open = row => {
      params.tagIds = row.tags.map(i => i.tagId);
      params.id = row.id;
      showDialog.value = true;
    };
    const formRef = ref(null);
    const emit = __emit;
    const loading = ref(false);
    const handleConfig = () => {
      formRef.value.validate(async valid => {
        if (!valid) return;
        try {
          loading.value = true;
          const {
            data
          } = await api.editTag(params);
          if (data.code !== 0) return;
          showDialog.value = false;
          ElMessage.success(t("action.success"));
          emit("loadList");
        } finally {
          loading.value = false;
        }
      });
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => showDialog.value = $event),
        width: "35%",
        title: _ctx.$t('common.edit') + _ctx.$t('users.form.tag')
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => showDialog.value = false),
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: loading.value,
          onClick: handleConfig
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          size: "large",
          model: params,
          ref_key: "formRef",
          ref: formRef,
          rules: rules,
          style: {
            "height": "200px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('users.form.tag'),
            prop: "tagIds"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              clearable: "",
              modelValue: params.tagIds,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.tagIds = $event),
              teleported: false,
              "collapse-tags": "",
              "max-collapse-tags": 1,
              multiple: "",
              placeholder: _ctx.$t('common.pleaseSelect', {
                val: _ctx.$t('users.form.tag')
              })
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.labelList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};